module.exports = __webpack_public_path__ + "images/common/lp/form-btn-sp_545c8d916626f695f562b0351d96d59d.png";